import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetch, create } from '../store/busesSlice';
import { useState } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { useModals } from '@mattjennings/react-modal-stack';
import ImagePickerModal from '../components/ImagePickerModal';
import { toast } from 'react-toastify';



function CreateBus(props) {
    const { openModal } = useModals();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const [ name, setName ] = useState('');

    async function onSubmit() {
        const res = await unwrapResult(await dispatch(create({
            name
        })));
        if(!res) return;

        const { id } = res;

        toast.success('Uus buss loodud!');

        function callback() {
            dispatch(fetch({ id }));
            navigate('/platform/resources');
        }

        openModal(ImagePickerModal, { title: name, url: `/bus/${id}/photo`, callback });
    }




    return (
        <div className="row p32 center-main">
            <div className="column g32">
                <h1>Loo buss</h1>

                <div className="line center-cross g32">

                    <div className="grow column g16">
                        <div className="column g4">
                            <b>Nimi</b>
                            <input type="text" autocomplete="off" value={name} onChange={(e) => setName(e.target.value)} />
                        </div>
                    </div>
                </div>

                <button onClick={onSubmit}>Loo buss</button>
            </div>
        </div>
    );
};

export default CreateBus;